import React from 'react'
import ImageGenerator from '../ImageGenerator'
import './styles.scss'
import { Link } from 'gatsby'

export const BannerGenerator = ({ data, name }) => {
  return (
    <ImageGenerator>
      {
        data.map((img, ind) => {
          return (
            <div key={ind} className="banner">
              {img.link ?
                <Link to={img.link}>
                  <img alt={img.alt_text || name} src={img.image} />
                </Link>
                :
                <img alt={img.alt_text || name} src={img.image} />
              }
            </div>
          )
        })
      }
    </ImageGenerator>
  )
}

export default React.memo(BannerGenerator, () => { return true })